import { Button } from '@material-ui/core';
import React, { useContext, useState } from 'react';
import { useHistory, useLocation } from 'react-router';
import { Link } from 'react-router-dom';
import { FacebookLoginButton, GoogleLoginButton } from 'react-social-login-buttons';
import "./Register.css"
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import { UserContext } from '../../App';
import firebaseConfig from '../firebase.config'

firebase.initializeApp(firebaseConfig);

const Register = () => {
    const [loggedInUser, setLoggedInUser] = useContext(UserContext);
    const [pass, setPass] = useState('')
    const history = useHistory();
    const location = useLocation();
    const { from } = location.state || { from: { pathname: "/" } };

    const [errorMsg, setErrorMsg] = useState('');
    const [formState, setFromState] = useState(false);

    const [isPassConfirm, setIsPassConfirm] = useState(false);

    const [user, setUser] = useState({
        isSignedIn: false,
        name: '',
        email: '',
        password: '',
        photo: ''
    });

    //handle input fields value on blur
    const handleBlur = (e) => {
        let isFieldValid = true;
        if (e.target.name === 'email') {
            isFieldValid = /\S+@\S+\.\S+/.test(e.target.value);
        }
        if (e.target.name === 'password') {
            const isPasswordValid = e.target.value.length > 6;
            const passwordHasNumber = /\d{1}/.test(e.target.value);
            isFieldValid = isPasswordValid && passwordHasNumber;
            setPass(e.target.value);
        }
        if (e.target.name === 'password2') {
            const value = e.target.value;
            if( value === pass ) {
                setIsPassConfirm(true);
            }
        }
        if (isFieldValid) {
            const newUserInfo = { ...user };
            newUserInfo[e.target.name] = e.target.value;
            setUser(newUserInfo);
        }
    }


    const handlePassMatch = (isPass) => {
        if (isPass){
            return <p> Password Matched!</p>
        } else return <p>Password Not Matched!</p>
    }

    //facebooklogin handler
    const handleFacebookLogin = () => {
        const facebookProvider = new firebase.auth.FacebookAuthProvider();
        return firebase.auth().signInWithPopup(facebookProvider).then(function (result) {
            var user = result.user;
            user.success = true;
            const { displayName, email } = result.user;
            const signedInUser = { name: displayName, email }
            setLoggedInUser(signedInUser);
            history.replace(from);
        }).catch(function (error) {
            const errorMessage = error.message;
            console.log(errorMessage);
        });
    }

    //google Login handler
    const handleGoogleLogin = () => {
        var googleProvider = new firebase.auth.GoogleAuthProvider();
        firebase.auth().signInWithPopup(googleProvider).then(function (userCredential) {
            const { displayName, email } = userCredential.user;
            const signedInUser = { name: displayName, email }
            setLoggedInUser(signedInUser);
            history.replace(from);
        }).catch(function (error) {
            const errorMessage = error.message;
            console.log(errorMessage);
        });
    }


    //submit handler for creating user
    const handleSubmit = (event) => {
        event.preventDefault();
          firebase.auth().createUserWithEmailAndPassword(user.email, user.password)
              .then((userCredential) => {
                  // Signed in 
                  var user = userCredential.user;
                  history.replace('/login')
              })
              .catch((error) => {
                  var errorCode = error.code;
                  var errorMessage = error.message;
                  setErrorMsg(errorMessage);
              });
  }

    return(
            <div className="register-body">
                <div className="register-top">
                    <div>Existing User?</div>
                    <Link to="/login"><Button variant="contained" color="primary">
                        Login
                    </Button>
                    </Link>
                </div>
                <form onSubmit={handleSubmit}>
                    <input name="name" type="text" onBlur={handleBlur} placeholder="Your name" />
                    <br />
                    <input type="text" name="email" onBlur={handleBlur} placeholder="Your Email address" required="Please enter valid email address" />
                    <br />
                    <input type="password" name="password" onBlur={handleBlur} placeholder="Your Password" required />
                    <br />
                    <input type="password" name="password2" onBlur={handleBlur} onChange={() => (setFromState(true))} placeholder="Confirm Password" required />
                    <br /> { formState ? handlePassMatch(isPassConfirm) : false }
                    {errorMsg !== '' ? <p>{errorMsg}</p> : false }
                    <input type="submit" className="btn btn-primary" />
                </form>
                <FacebookLoginButton onClick={handleFacebookLogin} />
                <GoogleLoginButton onClick={handleGoogleLogin} />
            </div>
        );
};

export default Register;